import { UUID } from '../common';

export const MAX_DECA_DOCUMENT_SEGMENTS = 10;

export interface IDecaDocument {
  id: UUID;
  reference?: string;

  shipper: IDecaDocumentCompany;
  carrier: IDecaDocumentCompany;

  segments: IDecaDocumentSegment[];

  specialAuthorizationType?: string; // maybe deprecated? only for for shipment or for segment?

  tractorPlateNumber?: string;
  trailerPlateNumber?: string;

  reservations: string[];
  eventLog: IDecaEventLog[]; // MUST BE ONLY FOR DETAILED

  pdfUrl: string;
  qrUrl: string;

  createdByCompanyId?: UUID;
  createdByContactId?: UUID;
  createdAt?: Date;
  updatedAt?: Date;

  // earliestStartingAt?: Date; // NOT NECESSARY
  // latestStartingAt?: Date; // NOT NECESSARY
}

export interface IDecaDocumentSegment {
  id: UUID;
  origin: IDecaDocumentStop;
  destination: IDecaDocumentStop;
  goodsDescription: string;
  netWeight?: number; // Fix in bridge commands-processored: must be optional / undefined
}

export interface IDecaDocumentStop {
  companyName: string;
  street: string;
  city: string;
  postalCode: string;
  stateCode: string;
  countryCode: string;
  date?: Date; // required in the command/query, but undefined in blank form
  // addressId?: UUID;
}

export interface IDecaDocumentCompany {
  id?: UUID;
  companyName?: string;
  taxId?: string;
  street?: string;
  city?: string;
  postalCode?: string;
  stateCode?: string;
  countryCode?: string;
  contactId?: UUID;
  contactFirstName?: string;
  contactLastName?: string;
  contactEmail?: string;
  contactPhone?: string;
  isShipper?: boolean;
  isCarrier?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface IDecaEventLog {
  occurredOn: Date;
  contactId: UUID;
  companyId: UUID;
  companyTaxId: string;
  description: string;
}

export interface IDecaCredits {
  availableCredits: number;
  promotionalCredits: number;
  promotionalCreditsExpireAt?: Date;
}

export type DecaDocumentCategory =
  | 'UPCOMING_DOCUMENTS_AS_SHIPPER'
  | 'UPCOMING_DOCUMENTS_AS_CARRIER'
  | 'PAST_DOCUMENTS_AS_SHIPPER'
  | 'PAST_DOCUMENTS_AS_CARRIER'
  | 'TODAY_DOCUMENTS_AS_DRIVER';

// View category suffix used by the lists (AS_SHIPPER / AS_CARRIER).
// Note: `DecaCompanyRole` below is the acting role (carrier | shipper) used when
// creating/editing a document; both express the carrier/shipper axis but with
// different value spellings and concerns.
export type DecaDocumentCompanyRole = 'AS_SHIPPER' | 'AS_CARRIER';

export type DecaCompanyRole = 'carrier' | 'shipper';

export type DecaStopType = 'origin' | 'destination';

// TODO probably not need this if we used signals, only for create new document form

export function getEmptyDecaDocument(): IDecaDocument {
  const newDocument: IDecaDocument = {
    id: '',
    reference: '',
    shipper: getEmptyIDecaDocumentCompany(),
    carrier: getEmptyIDecaDocumentCompany(),
    specialAuthorizationType: '',
    tractorPlateNumber: '',
    trailerPlateNumber: '',
    pdfUrl: '',
    qrUrl: '',
    createdByCompanyId: '',
    createdByContactId: '',
    createdAt: undefined,
    updatedAt: undefined,
    reservations: [],
    eventLog: [],
    segments: [getEmptyDecaDocumentSegment()],
  };
  return newDocument;
}

export function getEmptyDecaDocumentSegment(): IDecaDocumentSegment {
  return {
    id: crypto.randomUUID(),
    origin: getEmptyIDecaDocumentStop(),
    destination: getEmptyIDecaDocumentStop(),
    goodsDescription: '',
    netWeight: undefined,
  };
}

export const getEmptyIDecaDocumentCompany = (): IDecaDocumentCompany => ({
  id: '',
  companyName: '',
  taxId: '',
  street: '',
  city: '',
  postalCode: '',
  stateCode: '',
  countryCode: '',
  contactId: '',
  contactFirstName: '',
  contactLastName: '',
  contactEmail: '',
  contactPhone: '',
});

export const getEmptyIDecaDocumentStop = (): IDecaDocumentStop => ({
  companyName: '',
  street: '',
  city: '',
  postalCode: '',
  stateCode: '',
  countryCode: '',
});
